/* import __COLOCATED_TEMPLATE__ from './form.hbs'; */
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SignInTokenForm extends Component {
  @service currentPractice;
  @service signIn;

  @reads('currentPractice.useBookAppointmentLanguage') useBookAppointmentLanguage;
}
